<template>
  <div class="relative rounded-md shadow-sm">
    <div v-if="showSpinner" class="flex items-center pointer-events-none">
      <input
        type="text"
        class="form-input block w-full border border-gray-300 rounded-md shadow-sm sm:text-sm sm:leading-5 disabled:cursor-not-allowed disabled:opacity-50"
        disabled="disabled"
      />
      <LoadingSpinner
        class="w-8 text-gray-400 absolute inset-y-0 right-0 mt-2 flex items-center pointer-events-none"
      />
    </div>
    <div v-else>
      <model-select
        required="true"
        :options="reducedOptions"
        v-model="variant_id"
        placeholder="Select Variant"
        @searchchange="filterOptions"
        :isDisabled="loading"
      >
      </model-select>
    </div>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import { ApiFactory } from "@/api/ApiFactory.js";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "VariantSelect",
  components: {
    ModelSelect,
  },
  props: {
    reduceOpts: {
      type: Number,
      default: 0,
      required: false,
    },
    filters: { type: Array, default: () => [] },
    productId: Number,
    returnVariantDetails: {
      type: Boolean,
      default: false,
    },
    includeJumbo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: [],
      optionSearch: "",
      variants: [],
      variant_id: null,
      loading: true,
      loadingSkus: true,
    };
  },
  methods: {
    filterOptions(search) {
      if (search) {
        this.optionSearch = search;
      }
    },
    reset() {
      this.options = [];
      this.optionSearch = "";
      this.variants = [];
      this.variant_id = null;
      this.loading = true;
    },
  },
  computed: {
    reducedOptions() {
      if (this.reduceOpts === 0) return this.options;

      return this.options
        .filter((option) => {
          return option.text
            .toLowerCase()
            .includes(this.optionSearch.toLowerCase());
        })
        .slice(0, this.reduceOpts);
    },
    hasProductId() {
      return this.productId !== undefined;
    },
    showSpinner() {
      if (this.productId === null) return false;
      return this.loading;
    },
  },
  created() {},
  watch: {
    variant_id() {
      if (this.returnVariantDetails) {
        this.variants.find((variant) => {
          if (variant.id === this.variant_id) {
            this.$emit("variant-details", variant);
          }
        });
      }
      this.$emit("change-handler", this.variant_id);
    },
    productId() {
      this.reset();
      ApiFactory.get("inventories")
        .productVariants(this.productId)
        .then((response) => {
          this.variants = response.data.body;
          this.options = this.variants
            .filter((variant) => {
              const matchesFilters = this.filters.every(
                (filter) => variant[filter.key] === filter.value
              )

              const matchesJumbo = (this.includeJumbo || variant.jumbo === false)
              return matchesFilters && matchesJumbo;
            })
            .sort((a, b) => {
              if (
                a?.container_size_id === null &&
                b?.container_size_id !== null
              ) {
                return 1; // a should come after b
              }

              if (
                a?.container_size_id !== null &&
                b?.container_size_id === null
              ) {
                return -1; // a should come before b
              }

              if (a?.container_size_id && b?.container_size_id) {
                //compare the container sizes text
                return a?.container_size?.localeCompare(b.container_size);
              }

              return a?.plant_height?.localeCompare(b.plant_height);
            })
            .map((variant) => {
              return {
                value: variant.id,
                text:
                  (variant.variant_name ?? variant.id) +
                  (variant.historical_name
                    ? ` (${variant.historical_name})`
                    : ""),
              };
            });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  async beforeMount() {},
};
</script>
